// Empty stand-in for optional native requires (pdfjs-dist -> `canvas`).
module.exports = {};
